import React, { createContext, useReducer } from "react";
import CreditNoteReportReducer from "../../reducers/reports/creditNoteReportReducer";
import axios from "../../../axios";

const initialState = {
  loading: false,
  creditNotes: [],
  totalAmount: 0,
  totalVAT: 0,
  totalCredit: 0,
  count: 0,
  error: null,
  clients: [],
};

export const CreditNoteReportContext = createContext(initialState);

export const CreditNoteReportProvider = ({ children }) => {
  const [state, dispatch] = useReducer(CreditNoteReportReducer, initialState);

  // ✅ Get Credit Note Report
  const getCreditNoteReportHandler = async (filter) => {
    try {
      const result = await axios.get(
        `/api/v1/bookings/creditnotereport?${filter}`,
      );

      dispatch({
        type: "FETCH_CREDIT_NOTE_RECORDS",
        payload: result.data,
      });
    } catch (error) {
      console.error(error);
      dispatch({
        type: "PROCESS_ERROR",
        payload: error,
      });
    }
  };

  // ✅ Get Clients (same as proforma)
  const getClientsHandler = async (company) => {
    try {
      const result = await axios.get(`/api/v1/clients?companyName=${company}`);
      dispatch({
        type: "FETCH_CLIENT_RECORD",
        payload: result.data,
      });
    } catch (error) {
      console.error(error);
    }
  };

  // ✅ Clear State
  const clearCreditNoteStateHandler = () => {
    dispatch({ type: "PROCESS_START" });
  };

  return (
    <CreditNoteReportContext.Provider
      value={{
        loading: state.loading,
        creditNotes: state.creditNotes,
        clients: state.clients,

        totalAmount: state.totalAmount,
        totalVAT: state.totalVAT,
        totalCredit: state.totalCredit,
        count: state.count,

        error: state.error,

        getCreditNoteReportHandler,
        clearCreditNoteStateHandler,
        getClientsHandler,
      }}
    >
      {children}
    </CreditNoteReportContext.Provider>
  );
};
